<div class="modal-lembrete" [formGroup]="form" appArrastarFecharSheet [arrastarHabilitado]="arrastarParaFechar" (arrastouParaFechar)="fechar()">
  <div class="modal-lembrete-scroll flex-direction-column gap-15">
    <div class="flex-direction-row justify-between align-center">
      <span class="modal-lembrete-titulo">{{ tituloModal }}</span>
      <button type="button" class="modal-lembrete-fechar-x" title="Fechar" (click)="fechar()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="modal-lembrete-corpo">
      <div class="modal-lembrete-corpo-linha-wrap">
        <div class="modal-lembrete-linha"></div>
        <div class="flex-direction-column gap-15">
          @if (carregando) {
            <div class="modal-lembrete-skeleton-bloco skeleton" style="height: 56px"></div>
            <div class="modal-lembrete-skeleton-bloco skeleton" style="height: 40px; border-radius: 10px"></div>
            <div class="flex-direction-column gap-5">
              <div class="modal-lembrete-skeleton-label skeleton"></div>
              <div class="modal-lembrete-skeleton-bloco skeleton" style="height: 40px"></div>
            </div>
            <div class="flex-direction-row gap-10">
              <div class="modal-lembrete-skeleton-bloco skeleton" style="flex: 1; height: 40px"></div>
              <div class="modal-lembrete-skeleton-bloco skeleton" style="flex: 1; height: 40px"></div>
            </div>
            <div class="flex-direction-column gap-5">
              <div class="modal-lembrete-skeleton-label skeleton"></div>
              <div class="modal-lembrete-skeleton-bloco skeleton" style="height: 40px"></div>
            </div>
            <div class="flex-direction-column gap-5">
              <div class="modal-lembrete-skeleton-label skeleton"></div>
              <div class="modal-lembrete-skeleton-bloco skeleton" style="height: 40px"></div>
            </div>
            <div class="flex-direction-row" style="justify-content: flex-end">
              <div class="modal-lembrete-skeleton-bloco skeleton" style="height: 90px; width: 85%"></div>
            </div>
            <div class="flex-direction-column gap-5">
              <div class="modal-lembrete-skeleton-label skeleton"></div>
              <div class="modal-lembrete-skeleton-bloco skeleton" style="height: 90px"></div>
            </div>
          } @else {
            <app-campo-busca-contato [contato]="contatoSelecionado" (contatoAlterado)="aoAlterarContato($event)"
              [label]="contatoSelecionado ? 'Contato' : 'Buscar Contato'"
              [permitirRemover]="!isVisualizacao"></app-campo-busca-contato>

            <app-campo-segmentado formControlName="tipo" [opcoes]="opcoesTipo"></app-campo-segmentado>

            @if (isVisualizacao) {
              <div class="flex-direction-column gap-5">
                <span class="campo-label">Título</span>
                <span class="campo-valor-texto">{{ form.get('titulo')?.value }}</span>
              </div>
            } @else {
              <app-campo-texto formControlName="titulo" label="Título" placeholder="Ex: Retornar sobre a proposta comercial"
                [erro]="erroTitulo"></app-campo-texto>
            }

            <div class="flex-direction-row gap-10">
              @if (isVisualizacao) {
                <div class="flex-direction-column gap-5" style="flex: 1">
                  <span class="campo-valor-com-icone">
                    <img src="./assets/icones/redesign/inputs/input-date-calendar.svg" alt="" />
                    <span class="campo-valor-texto">{{ dataFormatadaTexto }}</span>
                  </span>
                </div>
                <div class="flex-direction-column gap-5" style="flex: 1">
                  <span class="campo-valor-com-icone">
                    <img src="./assets/icones/redesign/inputs/input-time-clock.svg" alt="" />
                    <span class="campo-valor-texto">{{ form.get('hora')?.value }}</span>
                  </span>
                </div>
              } @else {
                <app-campo-data formControlName="data" [label]="''" [dataMinima]="dataMinima" [erro]="erroData"></app-campo-data>
                <app-campo-hora formControlName="hora" [label]="''" [erro]="erroHora"></app-campo-hora>
              }
            </div>

            <app-campo-textarea formControlName="anotacao" label="Anotação"
              placeholder="Escreva sua anotação sobre o contato..." [maxLength]="250"></app-campo-textarea>

            @if (exibirTemplate) {
              @if (isVisualizacao) {
                @if (carregandoDetalhesTemplate) {
                  <div class="flex-direction-column gap-5">
                    <div class="modal-lembrete-skeleton-label skeleton"></div>
                    <div class="modal-lembrete-skeleton-bloco skeleton" style="height: 16px"></div>
                  </div>
                  <div class="flex-direction-column gap-5">
                    <div class="modal-lembrete-skeleton-label skeleton"></div>
                    <div class="modal-lembrete-skeleton-bloco skeleton" style="height: 16px"></div>
                  </div>
                } @else {
                  <div class="flex-direction-column gap-5">
                    <span class="campo-label">Template</span>
                    <span class="campo-valor-texto">{{ nomeTemplateEscolhido || '-' }}</span>
                  </div>
                  @if (etapaSelecionadaTexto) {
                    <div class="flex-direction-column gap-5">
                      <span class="campo-label">Etapa / Canal de envio</span>
                      <span class="campo-valor-texto">{{ etapaSelecionadaTexto }}</span>
                    </div>
                  }
                }
              } @else {
                <app-campo-select formControlName="templateId" [lista]="templates" campo="id" subCampo="nome" label="Template"
                  placeholder="Selecione um template" [habilitarBusca]="true" [carregando]="carregandoTemplates"
                  [erro]="erroTemplate" (selecionarItem)="onTemplateSelecionado($event)"></app-campo-select>

                @if (bloqueadoSemEtapa) {
                  <span class="campo-erro-texto">{{ mensagemBloqueio }}</span>
                }
                @if (etapasOpcoes.length > 0 || resolvendoRedirecionamento) {
                  <app-campo-select formControlName="etapaId" [lista]="etapasOpcoes" campo="descricaoEtapaCanal"
                    label="Etapa / Canal de envio" placeholder="Selecione a etapa/canal" [carregando]="resolvendoRedirecionamento"></app-campo-select>
                }
              }

              @if (carregandoDetalhesTemplate) {
                <div class="flex-direction-column gap-5">
                  <div class="modal-lembrete-skeleton-label skeleton"></div>
                  <div class="flex-direction-row" style="justify-content: flex-end">
                    <div class="modal-lembrete-skeleton-bloco skeleton" style="height: 90px; width: 85%"></div>
                  </div>
                </div>
              } @else if (urlImagemHeader || previaMensagem) {
                <div class="flex-direction-column gap-5">
                  <span class="campo-label">Prévia da mensagem</span>
                  <div class="balao-previa-container">
                    <div class="balao-previa-bolha">
                      @if (urlImagemHeader) {
                        <img [src]="urlImagemHeader" (click)="abrirImagemPrevia()" class="balao-previa-imagem" alt="Imagem do template" />
                      }
                      @if (previaMensagem) {
                        <div class="balao-previa-texto">{{ previaMensagem }}</div>
                      }
                      <div class="balao-previa-rodape">
                        <span class="balao-previa-hora">{{ horaFormatadaPreview }}</span>
                        <mat-icon class="balao-previa-check">done_all</mat-icon>
                      </div>
                    </div>
                  </div>
                </div>
              }
            }

            @if (!isVisualizacao) {
              <app-botao label="Salvar" [icone]="''" largura="100%" [disabled]="salvando || bloqueadoSemEtapa" (aoClicar)="salvar()"></app-botao>
            }
            @if (isEdicao && !isVisualizacao && lembretePodeProcessar) {
              <app-botao label="Processar agora" [icone]="''" corFundo="#ffffff" corTexto="var(--primary)" corBorda="var(--primary)"
                largura="100%" [disabled]="processando" (aoClicar)="confirmarProcessar()"></app-botao>
            }
            @if (isEdicao && !isVisualizacao && lembretePodeExcluir) {
              <app-botao label="Excluir" [icone]="''" corFundo="#ffffff" corTexto="var(--vermelho-padrao)" corBorda="var(--vermelho-padrao)"
                largura="100%" [disabled]="excluindo" (aoClicar)="confirmarExcluir()"></app-botao>
            }
          }
        </div>
      </div>
    </div>
  </div>
</div>
